import { Phone, ShoppingCart } from "lucide-react";
import { BRAND } from "@/lib/content";
import { useCart } from "@/context/CartContext";

export const SiteHeader = () => {
  const { count, setDrawerOpen } = useCart();
  return (
    <header className="sticky top-0 z-40 border-b border-neutral-200 bg-white/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <a href="/" className="flex items-center gap-2.5" data-testid="brand-logo">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-[var(--hp-crimson)] font-display text-base text-white">
            HP
          </span>
          <div className="leading-none">
            <div className="font-display text-lg text-neutral-900">{BRAND.name}</div>
            <div className="mt-0.5 text-[10px] font-bold uppercase tracking-[0.15em] text-[var(--hp-crimson)]">
              Ayurvedic Wellness
            </div>
          </div>
        </a>

        <div className="flex items-center gap-2 sm:gap-4">
          <a
            href={`tel:${BRAND.phone}`}
            data-testid="header-call-link"
            className="hidden items-center gap-2 rounded-full border border-neutral-200 px-3 py-2 text-sm font-semibold text-neutral-700 hover:border-[var(--hp-crimson)] hover:text-[var(--hp-crimson)] sm:flex"
          >
            <Phone className="h-4 w-4" />
            {BRAND.phone}
          </a>
          <button
            data-testid="header-cart-button"
            onClick={() => setDrawerOpen(true)}
            className="relative flex h-10 w-10 items-center justify-center rounded-full bg-neutral-900 text-white hover:bg-neutral-800"
          >
            <ShoppingCart className="h-5 w-5" />
            {count > 0 && (
              <span
                data-testid="header-cart-count"
                className="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-[var(--hp-gold-light)] px-1 text-xs font-bold text-white"
              >
                {count}
              </span>
            )}
          </button>
        </div>
      </div>
    </header>
  );
};
